module.exports = __webpack_public_path__ + "static/img/14010205.b7bb3016.png";